import { EnvioEmailNode } from './EnvioEmailNode'
import { CondicionNode } from './CondicionNode'

export const nodeTypes = {
  envioEmail: EnvioEmailNode,
  condicion: CondicionNode,
}

export { EnvioEmailNode, CondicionNode }
